<div class="row">
   <div class="col-lg-4">
      <div class="card shadow-sm">
         <div class="card-header">
            <h5 class="mb-0">{{editing?'Edit':'Add'}} {{tblData() && tblData().title}} Data</h5>
         </div>

         <div class="card-body">
            <div class="row mb-2">
              <div class="col-md-6">
                <label>Code <span class="required">*</span></label>
                <input class="form-control" [(ngModel)]="frmData.md_code" />
              </div>
              <div class="col-md-6">
                <label>Sort Order</label>
                <input
                    type="number"
                    class="form-control"
                    [(ngModel)]="frmData.sort_ord"
                />
              </div>
            </div>
            <div class="mb-3">
               <label>Name <span class="required">*</span></label>
               <input class="form-control" [(ngModel)]="frmData.md_name" />
            </div>

            <div class="mb-3">
               <label>Description</label>
               <textarea
                  rows="2"
                  class="form-control"
                  [(ngModel)]="frmData.description"
               ></textarea>
            </div>

            <div class="form-check mb-4">
               <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="frmData.is_active"
               />
               <label> Active </label>
            </div>

            <button class="btn btn-success me-2" (click)="save()">
               {{editing?'Update':'Save'}}
            </button>

            <button class="btn btn-secondary" (click)="reset()">Reset</button>
         </div>
      </div>
   </div>

   <div class="col-lg-8">
      <div class="card shadow-sm">
         <div class="card-header">
            <div class="row d-flex justify-content-between">
               <div class="col-md-5 d-flex align-items-center">
                  <h5 class="py-0 my-0">{{tblData() && tblData().title}} Data List</h5>
               </div>

               <div class="col-md-4">
                  <input
                     class="form-control form-control-sm"
                     placeholder="Search..."
                     [(ngModel)]="searchText"
                  />
               </div>

              <div class="btn-group col-md-3">
                <button type="button" class="btn btn-sm btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  {{tblData().title || 'Data Category'}}
                </button>
                <ul class="dropdown-menu dropdown-menu-end" style="max-height: calc(100vh - 135px); overflow: auto;">
                  @for(md of mdata4load; track md) {
                  <li *ngIf="user.user_role[0].code=='spr' && md.for_sa"><button class="dropdown-item" type="button" 
                    (click)="setMaster(md)">{{md.title}}</button>
                  </li>
                  <li *ngIf="!md.for_sa"><button class="dropdown-item" type="button" 
                    (click)="setMaster(md)">{{md.title}}</button>
                  </li>
                  }
                </ul>
              </div>
            </div>
         </div>

         <div class="table-responsive">
            <table class="table table-hover">
               <thead>
                  <tr>
                     <th>#</th>
                     <th (click)="sort('md_code')">Code</th>
                     <th (click)="sort('md_name')">Name</th>
                     <th>Description</th>
                     <th (click)="sort('sort_ord')">Sort</th>
                     <th>Status</th>
                     <th width="140">Action</th>
                  </tr>
               </thead>

               <tbody>
                  <tr *ngFor="let item of pagedData; let idx=index;">
                     <td>{{idx+1}}.</td>
                     <td>{{item.md_code}}</td>
                     <td>{{item.md_name}}</td>
                     <td>{{item.description}}</td>
                     <td>{{item.sort_ord}}</td>
                     <td>
                        <small
                           class="badge py-0 fw-semibold"
                           [ngClass]="item.is_active?'bg-success-subtle border border-success-subtle text-success-emphasis':'bg-danger-subtle border border-danger-subtle text-danger-emphasis'"
                        >
                           {{item.is_active?'Active':'Inactive'}}
                     </small>
                     </td>

                     <td>
                        <button
                           class="btn btn-sm me-1"
                           (click)="edit(item)"
                        >
                          <i class="bi bi-pencil-square text-success"></i>
                        </button>

                        <button
                           class="btn btn-sm"
                           (click)="deleteClick(item.id)"
                        >
                          <i class="bi bi-trash3-fill text-danger"></i>
                        </button>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>

         <div class="card-footer" *ngIf="totalPages()>1">
            <button
               class="btn btn-outline-primary btn-sm me-2"
               (click)="changePage(currentPage-1)"
            >
               Previous
            </button>

            Page {{currentPage}} / {{totalPages()}}

            <button
               class="btn btn-outline-primary btn-sm ms-2"
               (click)="changePage(currentPage+1)"
            >
               Next
            </button>
         </div>
      </div>
   </div>
</div>
